import { render, staticRenderFns } from "./QuizCategory.html?vue&type=template&id=196ea24e&scoped=true&external"
import script from "./QuizCategory.js?vue&type=script&lang=js&external"
export * from "./QuizCategory.js?vue&type=script&lang=js&external"
import style0 from "./QuizCategory.css?vue&type=style&index=0&id=196ea24e&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196ea24e",
  null
  
)

export default component.exports